import { SET_IS_FORM_OPEN, SET_UPDATE_SECTION } from "./types";
import { sectionIds } from "../constants";

export const updateIsOpen = ( type = sectionIds.PARENTS_AND_CHILDREN, value=false) => {
  return {
    type: SET_IS_FORM_OPEN,
    payload: {type, value},
  };
};


export const updateSection = ( value = '') => {
  return {
    type: SET_UPDATE_SECTION,
    payload: value,
  };
};
